import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const ChatSupportOutlined = ({
  size = 24,
  color = '#000',
  ...props
}: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)" fill={color}>
      <Path d="M14.96 4.56c1.17 0 2.11.95 2.11 2.11v3.34c0 1.17-.95 2.11-2.11 2.11H9.18c-.52 0-1.02.17-1.44.47l-3.18 1.89v-7.8c0-1.17.95-2.11 2.11-2.11h8.29m0-1.56H6.68C4.65 3.01 3 4.66 3 6.69v9.39a.67.67 0 0 0 1.01.58l4.62-2.74c.16-.13.35-.2.55-.2h5.78c2.03 0 3.68-1.65 3.68-3.68V6.7c0-2.03-1.65-3.68-3.68-3.68v-.01Z" />
      <Path d="M19.31 9.48v.87c0 .37-.07.72-.17 1.06.16.25.26.54.26.86v6.25l-2.33-1.38c-.4-.29-.88-.45-1.37-.45h-4.96c-.86 0-1.56-.7-1.56-1.56v-.89a1.1 1.1 0 0 0-.32.17l-1.28.76a3.15 3.15 0 0 0 3.15 3.12h4.96c.17 0 .34.06.48.17l3.96 2.35a.57.57 0 0 0 .86-.49v-8.06c0-1.21-.69-2.25-1.69-2.78h.01ZM11.23 5.3c.23 0 .43.08.59.25.16.17.25.36.25.59 0 .23-.08.43-.25.59-.17.16-.36.25-.59.25-.23 0-.43-.08-.59-.25a.834.834 0 0 1-.25-.59c0-.23.08-.43.25-.59.17-.16.36-.25.59-.25Zm-.72 2.02h1.44v3.95h-1.44V7.32Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default ChatSupportOutlined
